// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import bottom from '@/components/bottom'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/common.css';
import App from './App'
import router from './router'
Vue.component('bottom', bottom)
import request from '@/utils/request'
Vue.prototype.request = request
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  // template: '<App/>'
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js